import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/20/solid";

export default function UsermanMenu({ userman_id, device_name }) {
  return (
    <Menu as="div" className="relative inline-block">
      <MenuButton className="inline-flex w-full justify-center gap-x-1.5 rounded-md bg-white/10 px-3 py-2 text-sm font-semibold text-white inset-ring-1 inset-ring-white/5 hover:bg-white/20">
        User Manager
        <ChevronDownIcon
          aria-hidden="true"
          className="-mr-1 size-5 text-gray-400"
        />
      </MenuButton>

      <MenuItems
        transition
        className="absolute right-0 z-10 mt-2 w-56 origin-top-right rounded-md bg-gray-800 outline-1 -outline-offset-1 outline-white/10 transition data-closed:scale-95 data-closed:transform data-closed:opacity-0 data-enter:duration-100 data-enter:ease-out data-leave:duration-75 data-leave:ease-in"
      >
        <div className="py-1">
          <MenuItem>
            <a
              href={`/userman-router?userman_id=${userman_id}&device_name=${device_name}`}
              className="block px-4 py-2 text-sm text-gray-300 hover:bg-white/5 hover:text-white"
            >
              Router
            </a>
          </MenuItem>
          <MenuItem>
            <a
              href={`/userman-users?userman_id=${userman_id}&device_name=${device_name}`}
              className="block px-4 py-2 text-sm text-gray-300 hover:bg-white/5 hover:text-white"
            >
              Users
            </a>
          </MenuItem>
          <MenuItem>
            <a
              href={`/userman-user-group?userman_id=${userman_id}&device_name=${device_name}`}
              className="block px-4 py-2 text-sm text-gray-300 hover:bg-white/5 hover:text-white"
            >
              User Groups
            </a>
          </MenuItem>
          <MenuItem>
            <a
              href={`/userman-session?userman_id=${userman_id}&device_name=${device_name}`}
              className="block px-4 py-2 text-sm text-gray-300 hover:bg-white/5 hover:text-white"
            >
              Session
            </a>
          </MenuItem>
          <MenuItem>
            <a
              href={`/userman-profiles?userman_id=${userman_id}&device_name=${device_name}`}
              className="block px-4 py-2 text-sm text-gray-300 hover:bg-white/5 hover:text-white"
            >
              Profile
            </a>
          </MenuItem>
          <MenuItem>
            <a
              href={`/userman-user-profile?userman_id=${userman_id}&device_name=${device_name}`}
              className="block px-4 py-2 text-sm text-gray-300 hover:bg-white/5 hover:text-white"
            >
              User Profile
            </a>
          </MenuItem>
          <MenuItem>
            <a
              href={`/userman-limitation?userman_id=${userman_id}&device_name=${device_name}`}
              className="block px-4 py-2 text-sm text-gray-300 hover:bg-white/5 hover:text-white"
            >
              Limitation
            </a>
          </MenuItem>
          <MenuItem>
            <a
              href={`/userman-profile-limitation?userman_id=${userman_id}&device_name=${device_name}`}
              className="block px-4 py-2 text-sm text-gray-300 hover:bg-white/5 hover:text-white"
            >
              Profile Limitation
            </a>
          </MenuItem>
          <MenuItem>
            <a
              href={`/userman-attribute?userman_id=${userman_id}&device_name=${device_name}`}
              className="block px-4 py-2 text-sm text-gray-300 hover:bg-white/5 hover:text-white"
            >
              Attribute
            </a>
          </MenuItem>
        </div>
      </MenuItems>
    </Menu>
  );
}
